import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[(_vm.showPDF)?_c('iframe',{staticClass:"iframe-custom",attrs:{"src":_vm.src,"title":_vm.name,"frameborder":"0","scrolling":"no","allowfullscreen":""}}):_c(VProgressLinear,{attrs:{"color":"blue darken-2 accent-4","indeterminate":"","rounded":"","height":"6"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }